import { Button, Col, Form, Row, Spin } from "antd";
import { SaveOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import WithAuthenticated from "../../components/WithAuthenticated";
import ContentContainer from "../../components/ContentContainer";
import Breadcrumb from "../../components/Breadcrumb";
import TextEditor from "../../components/TextEditor";
import { PrivacyPolicy } from "../../interfaces/privacyPolicy.interface";
import { getPrivacyPolicy, updatePrivacyPolicy } from "../../api/privacyPolicy";
import alert from "../../components/AlertMessage";

export interface PrivacyPolicyForm {
  detail: string;
}

const Page = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [data, setData] = useState<PrivacyPolicy>();
  const [form] = Form.useForm<PrivacyPolicyForm>();

  useEffect(() => {
    setLoading(true);
    getPrivacyPolicy()
      .then((result) => {
        setData(result);
      })
      .catch(() => {
        alert({
          type: "error",
          content: "Failed to fetch privacy policy.",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    form.setFieldsValue({
      detail: data?.detail,
    });
  }, [data, form]);

  const handleFormFinish = (values: PrivacyPolicyForm) => {
    setLoading(true);
    updatePrivacyPolicy(values)
      .then((result) => {
        setData(result);
      })
      .catch(() => {
        alert({
          type: "error",
          content: "Failed to update privacy policy.",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <Breadcrumb
        title="Privacy Policy"
        items={[{ title: "Privacy Policy", location: "" }]}
      />
      <ContentContainer>
        <Row style={{ marginBottom: 20 }}>
          <Col
            style={{ display: "flex", justifyContent: "flex-end" }}
            span={24}
            sm={{ span: 10, offset: 14 }}
            md={{ span: 12, offset: 12 }}
          >
            <Button
              icon={<SaveOutlined />}
              type="primary"
              ghost
              onClick={() => {
                form.submit();
              }}
            >
              Save
            </Button>
          </Col>
        </Row>
        <Spin spinning={loading}>
          <Form form={form} layout="vertical" onFinish={handleFormFinish}>
            <Form.Item
              name="detail"
              rules={[{ required: true, message: "Input is required!" }]}
            >
              <TextEditor />
            </Form.Item>
          </Form>
        </Spin>
      </ContentContainer>
    </>
  );
};

export default WithAuthenticated(Page);
